module.exports = __webpack_public_path__ + "static/media/Invoker.ba3a852e.png";